import Vue from 'vue';
import Router from 'vue-router';
import { GuardFactory } from '@holdingblachere/vuex-auth';
import { GuardFactory as ShopGuardFactory } from '@holdingblachere/vuex-shop-auth';
import routes from './routes';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 }),
});

const authGuard = GuardFactory.CreateGuardMiddleware({
  store,
  prefix: 'auth',
  authenticatedRedirectRoute: 'Dashboard',
  guestRedirectRoute: 'Login',
});

const shopAuthGuard = ShopGuardFactory.CreateGuardMiddleware({
  store,
  prefix: 'shopAuth',
  authenticatedRedirectRoute: 'Login',
  guestRedirectRoute: 'Welcome',
});

router.beforeEach(authGuard);
router.beforeEach(shopAuthGuard);

export default router;
